export function PerfStat({ label, value, accent, hint }) {
  return (
    <div style={{ padding: '10px 12px', border: '1px solid #f0f0f0', borderRadius: 6 }}>
      <div style={{ fontSize: 10, fontWeight: 600, textTransform: 'uppercase', letterSpacing: 0.6, color: '#9e9e9e', marginBottom: 4 }}>{label}</div>
      <div style={{ fontSize: 22, fontWeight: 700, color: accent || '#212121', lineHeight: 1 }}>{value}</div>
      {hint && <div style={{ fontSize: 10, color: '#bdbdbd', marginTop: 4 }}>{hint}</div>}
    </div>
  );
}
